import React from 'react'
import { toast } from 'react-toastify'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'

import ContributorForm from './ContributorForm'
import {
  fetchContributor,
  updateContributor,
  createContributor,
  deleteContributor,
} from '../../../modules/portal-remote/portalService'
import config from '../../../config'
import { setContributor } from '../../../actions/contributor'

class ContributorFormContainer extends React.Component {
  state = {
    isEditing: true,
  }

  async componentDidMount() {
    this.props.actions.setContributor({})
    if (this.props.params.contributorID !== 'create') {
      try {
        const contributor = await fetchContributor(
          this.props.params.contributorID,
        )
        this.setState({ contributor })
      } catch (error) {
        toast.error(error.message)
      }
    }
  }

  initialValues = () => {
    return {
      name: config.getLangText(),
      position: config.getLangText(),
      contact: config.getLangText(),
      ...this.state.contributor,
    }
  }

  handleValidate = () => {
    const errors = {}
    return errors
  }

  handleSubmit = async values => {
    try {
      if (values._id) {
        await updateContributor(values)
        toast.success('Update Contributor Success')
      } else {
        await createContributor(values)
        toast.success('Create Contributor Success')
      }
      this.props.history.replace('/contributor')
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleDelete = async () => {
    try {
      if (_.get(this.state, 'contributor._id')) {
        await deleteContributor(this.state.contributor._id)
        toast.success('Create Contributor Success')
        this.props.history.replace('/contributor')
      }
    } catch (error) {
      toast.error(error.message)
    }
  }

  render() {
    return (
      <ContributorForm
        initialValues={this.initialValues()}
        onValidate={this.handleValidate}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        isEditing={this.state.isEditing}
      />
    )
  }
}

export default compose(
  withRouter,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({ setContributor: setContributor }, dispatch),
    }),
  ),
)(ContributorFormContainer)



// WEBPACK FOOTER //
// ./src/components/templates/contributor-form/ContributorFormContainer.js